// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DrrpBasetabmgrIconOutlinedSvg from "@fishx/icons-svg/es/asn/DrrpBasetabmgrIconOutlined";
import FishxIcon from '../components/FishxIcon';

var DrrpBasetabmgrIconOutlined = function DrrpBasetabmgrIconOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DrrpBasetabmgrIconOutlinedSvg
  }));
};

DrrpBasetabmgrIconOutlined.displayName = 'DrrpBasetabmgrIconOutlined';
export default React.forwardRef(DrrpBasetabmgrIconOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DrrpBasetabmgrIconOutlined.js
// module id = 2496
// module chunks = 0